import createIcon from '../../createIcon';

/**
 * @component @name Mood
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuOTkgMkM2LjQ3IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ3IDIyIDExLjk5IDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMS45OSAyWk0xMiAyMEM3LjU4IDIwIDQgMTYuNDIgNCAxMkM0IDcuNTggNy41OCA0IDEyIDRDMTYuNDIgNCAyMCA3LjU4IDIwIDEyQzIwIDE2LjQyIDE2LjQyIDIwIDEyIDIwWk0xNS41IDExQzE2LjMzIDExIDE3IDEwLjMzIDE3IDkuNUMxNyA4LjY3IDE2LjMzIDggMTUuNSA4QzE0LjY3IDggMTQgOC42NyAxNCA5LjVDMTQgMTAuMzMgMTQuNjcgMTEgMTUuNSAxMVpNOC41IDExQzkuMzMgMTEgMTAgMTAuMzMgMTAgOS41QzEwIDguNjcgOS4zMyA4IDguNSA4QzcuNjcgOCA3IDguNjcgNyA5LjVDNyAxMC4zMyA3LjY3IDExIDguNSAxMVpNMTIgMTcuNUMxNC4zMyAxNy41IDE2LjMxIDE2LjA0IDE3LjExIDE0SDYuODlDNy42OSAxNi4wNCA5LjY3IDE3LjUgMTIgMTcuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Mood = createIcon('Mood', [
  [
    'path',
    {
      d: 'M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z',
      key: '1g4ut7',
    },
  ],
]);

export default Mood;
